<template>
    <Button label="" icon="pi pi-pencil" class="p-button-sm" @click="showDialog" outlined severity="secondary" />

    <Dialog class="flex flex-column border-none max-w-30rem" modal
        v-model:visible="dialog"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px' }"
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Редактировать клиента</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-3">
            <div class="flex flex-column w-full gap-2">
                <span class="flex">Имя <span class="text-red-500">*</span>: </span>
                <InputText v-model="form.first_name" class="flex" placeholder="Иван" />
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Фамилия <span class="text-red-500">*</span>: </span>
                <InputText v-model="form.last_name" class="flex" placeholder="Иванов" />
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Email <span class="text-red-500">*</span>: </span>
                <InputText v-model="form.email" class="flex" placeholder="ivan@example.com" />
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Номер телефона <span class="text-red-500">*</span>: </span>
                <InputNumber v-model="form.phone" class="flex" placeholder="79998887766" :useGrouping="false" />
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Сохранить" @click="UpdateClient" :loading="loading" class="flex" :disabled="loading" severity="info" />
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading" />
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    props: {
        client: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            dialog: false,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
            },
        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        clientId() {
            return this.client?.id || null
        },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 })
        },
        // Работаем с локальной копией, чтобы не менять строку таблицы до успешного ответа API.
        syncForm() {
            this.form = {
                first_name: this.client?.first_name || '',
                last_name: this.client?.last_name || '',
                email: this.client?.email || '',
                phone: this.client?.phone || '',
            }
        },
        showDialog() {
            this.syncForm()
            this.dialog = true
        },
        async UpdateClient() {
            this.loading = true
            if(!this.clientId) {
                this.showMess('error', 'Ошибка', 'Не найден ID клиента')
                this.loading = false
                return
            }

            if(!this.form.first_name || !this.form.last_name || !this.form.email || !this.form.phone) {
                this.showMess('error', 'Ошибка', 'Заполните все обязательные поля')
                this.loading = false
                return
            }

            try {
                const update = await this.connect.UpdatePersonalClient(this.clientId, this.form).then(res => res)
                if(update.result) {
                    this.showMess('success', 'Успешно', 'Данные клиента обновлены')
                    this.dialog = false
                    this.$emit('updated', update.data)
                } else if(update.message) {
                    this.showMess('error', 'Ошибка', update.message)
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при обновлении клиента')
                }
            } catch(e) {
                this.showMess('error', 'Ошибка', 'Ошибка при обновлении клиента')
                console.log('error', e)
            }

            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>